module.exports = __webpack_public_path__ + "static/media/Religious Service Information Assistance.351a0c20.png";